import * as angular from 'angular';

const fdExternalDataSourceHtml = require('../../views/fd_external_data_source.html');

'use strict';

angular.module('formApp').directive('fdExternalDataSource', function () {
  return {
    templateUrl: fdExternalDataSourceHtml,
    scope: {
      properties: '=',
      models: '='
    },
    controller: 'fdExternalDataSourceCtrl',
    replace: true
  };
});
